import React, { useState } from 'react';
import { Popup } from 'antd-mobile';
import { useHistory } from 'react-router-dom';
import AiAnalysisTipPopup from './AiAnalysisTipPopup';

export default function AiAnalysisPopup({ visible, onClose, data, gameId }) {
  const history = useHistory();
  const [tipVisible, setTipVisible] = useState(false);
  if (!data) return null;

  const positive = parseFloat(data.positive_review) || 0;
  const average  = parseFloat(data.average_review)  || 0;
  const bad      = parseFloat(data.bad_review)       || 0;

  return (
    <>
    <Popup
      visible={visible}
      onMaskClick={onClose}
      bodyStyle={{
        borderRadius: '16px 16px 0 0',
        maxHeight: '85vh',
        display: 'flex',
        flexDirection: 'column',
        backgroundColor: '#F8F8F8',
      }}
    >
      {/* 标题栏 */}
      <div style={{ position: 'relative', padding: '20px 16px 12px', textAlign: 'center', flexShrink: 0 }}>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
          <div style={{ fontSize: 17, fontWeight: '500', color: '#282828', lineHeight: 1 }}>AI评论分析结果</div>
          <div style={{ paddingLeft: 4, display: 'flex', alignItems: 'center' }}>
            <img src="/resources/250424/ai_analysis.png" alt="" height={13} style={{ display: 'block' }} onClick={() => setTipVisible(true)}/>
          </div>
        </div>
        <div style={{ fontSize: 12, color: '#999', marginTop: 4 }}>
          (基于该游戏的所有评论)
        </div>
        <div
          onClick={onClose}
          style={{
            position: 'absolute', top: 18, right: 16,
            width: 28, height: 28, display: 'flex',
            alignItems: 'center', justifyContent: 'center',
            fontSize: 18, color: '#999', cursor: 'pointer',
          }}
        >✕</div>
      </div>

      {/* 滚动内容区 */}
      <div style={{ overflowY: 'auto', flex: 1, padding: '0 16px' }}>

        {/* 高频关键词 */}
        {data.high_frequency_keywords?.length > 0 && (
          <div style={{ marginBottom: 8 ,backgroundColor:'white',borderRadius:10,padding:'13px 15px'}}>
            <div style={{ fontSize: 15, fontWeight: '500', color: '#282828', marginBottom: 12 }}>高频关键词</div>
            <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8 }}>
              {data.high_frequency_keywords.map((kw, i) => (
                <span key={i} style={{
                  padding: '1px 10px',
                  background: '#99999916',
                  borderRadius: 10,
                  fontSize: 12,
                  color: '#666',
                }}>{kw}</span>
              ))}
            </div>
          </div>
        )}

        {/* 评论分析总结 */}
        {data.summary && (
          <div style={{ marginBottom: 16 ,backgroundColor:'white',borderRadius:10,padding:'13px 15px'}}>
            <div style={{ fontSize: 15, fontWeight: '500', color: '#282828', marginBottom: 10 }}>评论分析总结</div>
            <div style={{ fontSize: 14, color: '#666', lineHeight: 1.7 }}>{data.summary}</div>
          </div>
        )}

        {/* 更新时间 & 免责提示 */}
        <div style={{ fontSize: 12, color: '#999', marginBottom: 8 ,paddingLeft:5}}>
          {data.time && <div>数据更新于 {data.time}</div>}
        </div>
      </div>

      {/* 底部按钮 */}
      <div style={{ padding: '12px 35px', paddingBottom: 'calc(12px + env(safe-area-inset-bottom))', flexShrink: 0 }}>
        <div
          onClick={() => {
            onClose();
            if (gameId) history.push(`/gameCommunity?topic_id=${gameId}&circles_type=game`);
          }}
          style={{
            background: 'var(--MainColor)',
            borderRadius: 24,
            height: 48,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontSize: 18,
            color: '#fff',
            cursor: 'pointer',
          }}
        >
          查看全部评论
        </div>
      </div>
    </Popup>
    <AiAnalysisTipPopup visible={tipVisible} onClose={() => setTipVisible(false)} />
    </>
  );
}

function LegendItem({ color, label, value }) {
  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: 5 }}>
      <div style={{ width: 10, height: 10, borderRadius: '50%', background: color, flexShrink: 0 }} />
      <div style={{ fontSize: 12, lineHeight: '16px', color: '#282828' }}>{label}（{value.toFixed(0)}%）</div>
    </div>
  );
}
